<template>
  <div>
    <v-textarea
      outlined
      name="user-note"
      id="js-user-note"
      label="Add Mentee Note"
      v-model="newUserNote"
    ></v-textarea>
    <v-btn
      id="js-add-user-note-btn"
      class="default-action-btn"
      small
      tile
      @click="addUserNote()"
      >Add Note</v-btn
    >
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      newUserNote: ""
    }
  },
  methods: {
    addUserNote() {
      this.$emit("add-user-note-event", { noteBody: this.newUserNote })
      this.newUserNote = ""
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

// .custom-btn {
//   background-color: $dark-blue !important;
//   color: $white;
// }

// .custom-btn:hover {
//   background-color: $orange !important;
//   color: $white !important;
// }
</style>
